/* eslint-disable @typescript-eslint/no-explicit-any */
import { useCallback } from 'react'
import {
    downloadCSV,
    // useTranslate,
} from 'react-admin'
import jsonExport from 'jsonexport/dist'
// import DownloadIcon from '@mui/icons-material/GetApp'
import { RecordParser, UseProductExportResult } from './type'
// import { PRODUCTS_COMMON_FIELDS } from '../providers/localization/constant'
// import { ExportButton } from '../components/buttons'
// import { IMenuItem } from '../components/list-actions/type'

export const useProductExport = (fileName: string, fn: RecordParser,): UseProductExportResult => {
    // const translate = useTranslate()
    const exporter = useCallback((records: any): void => {
        const recordsForExport = fn(records)

        jsonExport(recordsForExport, {}, (err, csv) => {
            downloadCSV(csv, fileName) // download as 'posts.csv` file
        })
        return
    }, [fileName, fn])

    return {
        exporter,
    } as unknown as UseProductExportResult
}